import React, { useEffect, useState } from "react";
import { api, resolveImg } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { BookButton } from "@/components/site/BookButton";
import { Seo } from "@/components/site/Seo";

export default function PatientStories() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <Seo title="Patient Stories | Psalm 30:2 Chiropractic Gardner KS" description="Real experiences from patients and families at Psalm 30:2 Chiropractic in Gardner, Kansas." />
      <PageHero eyebrow="Patient Stories" title={<>What our patients<br />wanted back.</>} intro="Every story starts with something someone wanted to return to. These are lived experiences — shared with permission, and never a guarantee of anyone else's result." />
      <section className="bg-ivory pb-8 px-6 md:px-10 lg:px-14" data-testid="stories-list">
        <div className="max-w-[1500px] mx-auto space-y-28 lg:space-y-40">
          {items.map((t, i) => (
            <div key={t.id || t.name} className={`grid lg:grid-cols-12 gap-10 lg:gap-16 items-center`}>
              <Reveal className={`lg:col-span-5 ${i % 2 ? "lg:order-2" : ""}`}>
                <div className="overflow-hidden rounded-sm aspect-[4/5]">
                  <img src={resolveImg(t.image)} alt={t.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
              </Reveal>
              <Reveal delay={120} className={`lg:col-span-7 ${i % 2 ? "lg:order-1" : ""}`}>
                <blockquote className="font-serif font-light text-3xl lg:text-5xl leading-[1.15] text-espresso mb-10">"{t.quote}"</blockquote>
                <div className="grid sm:grid-cols-2 gap-x-10 gap-y-6">
                  {[["Before care", t.before], ["Wanted back", t.wanted], ["What changed", t.changed], ["Now", t.now]].map(([label, val]) =>
                    val ? (
                      <div key={label}>
                        <div className="overline mb-2">{label}</div>
                        <p className="text-espressosoft/80 font-light leading-relaxed">{val}</p>
                      </div>
                    ) : null
                  )}
                </div>
                <div className="mt-8 text-sm uppercase tracking-[0.16em] text-taupe">{t.name} · {t.location}</div>
              </Reveal>
            </div>
          ))}
        </div>
      </section>
      <section className="bg-linen py-24 px-6 text-center mt-24">
        <Reveal>
          <h2 className="font-serif font-light text-4xl lg:text-5xl text-espresso mb-8">Write your own story.</h2>
          <BookButton label="Book Your Visit" variant="primary" track_label="stories" testid="stories-book-button" />
        </Reveal>
      </section>
    </div>
  );
}
